export default "__VITE_ASSET__a0002c96__"